import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/match-management";

export const List  = async (values) => {
  return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Delete = async (id) => {
  return await axiosInstance(options).delete(`${path}/${id}`);
}

export const DeleteAll = async () => {
  return await axiosInstance(options).delete(`${path}/delete-all`);
}

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
}

export const Teams = async (clubAdminId) => {
  return await axiosInstance(options).get(`${path}/teams?clubAdminId=${clubAdminId}`);
}

export const Scorers = async (clubAdminId) => {
  return await axiosInstance(options).get(`${path}/scorers?clubAdminId=${clubAdminId}`);
}

export const TeamPlayers = async (teamId) => {
  return await axiosInstance(options).get(`${path}/team-players/${teamId}`);
}

export const ExtraGameActions = async () => {
  return await axiosInstance(options).get(`common/extra-game-actions/list`);
}

export const ControlMatch = async (matchId, payload) => {
  return await axiosInstance(options).put(`common/match/${matchId}/control`, payload);
}

export const AddMatchAction = async (matchId, payload) => {
  return await axiosInstance(options).post(`common/match/${matchId}/event`, payload);
}

export const CommonMatchDetails = async (id) => {
  return await axiosInstance(options).get(`common/match/${id}`);
}

export const GetTeamInsights = async (teamId, matchId) => {
  return await axiosInstance(options).get(`admin/reports/team-insights?teamId=${teamId}&matchId=${matchId}&tab=all`);
}

export const GetRawEvents = async (teamId, matchId) => {
  const query = [];
  if (teamId) query.push(`teamId=${teamId}`);
  if (matchId) query.push(`matchId=${matchId}`);
  return await axiosInstance(options).get(`admin/reports/raw-events?${query.join("&")}`);
}

export const GetMatchAnalysis = async (matchId, teamId) => {
  const query = teamId ? `matchId=${matchId}&teamId=${teamId}` : `matchId=${matchId}`;
  return await axiosInstance(options).get(`club-admin/home/match-analysis?${query}`);
}

